import { createContext } from "react";
import { type Delivery } from "../utils/types";

// This is what we use for taking all the picups from the PickupContext and transforming them into a format that can be used for our printable tables.

export interface DeliveryContextType {
  deliveries: Delivery[];
  loading: boolean;
  error: string | null;
}

export const DeliveryContext = createContext<DeliveryContextType>({
  deliveries: [],
  loading: false,
  error: null,
});

